<template>
  <IQOS :title="index == -1 ? 'Нова акція' : `Акція №${index}`">
    <div class="discount-box">
      <h4>
        Період акції:
        <p
          v-if="!editing"
        >{{ promotion.period_start | formatDate }} - {{ promotion.period_end | formatDate }}</p>
        <!-- <BaseInput placeholder="sad" v-else class="ml-auto" /> -->
        <v-date-picker v-model="range" class="promotion-period mt-3 ml-auto" mode="range" locale="uk" is-dark color="green" v-if="editing"/>
      </h4>
      <h4>
        Меню:
        <p v-if="!editing">{{ promotion.menu_id ? findMenu(promotion.menu_id).title : '-' }}</p>
        <!-- <BaseInput placeholder="sad" v-else class="mt-3 ml-auto" /> -->
        <BlackSelect class="mt-3 ml-auto" v-model="promotion.menu_id" v-if="editing">
          <option :value="null" disabled>- Оберіть меню -</option>
          <option v-for="menu in menus" :key="menu._id" :value="menu._id">
            {{ menu.title }}
          </option>
        </BlackSelect>
      </h4>
      <h4>
        Тип:
        <p v-if="!editing">Знижка на все меню</p>
        <BaseInput :value="`Знижка на все меню`" readonly v-else class="mt-3 ml-auto" />
      </h4>
      <h4>
        Знижка:
        <p v-if="!editing">{{promotion.discount}}%</p>
        <BaseInput
          v-model.number="promotion.discount"
          placeholder="10%"
          v-else
          class="mt-3 ml-auto"
          :readonly="false"
        />
      </h4>
      <div class="labels" v-if="!editing">
        <div class="label" v-if="promotion.modes.delivery">DELIVERY</div>
        <div class="label ml-2" v-if="promotion.modes.preorder">TAKEAWAY</div>

        <div class="label-active" v-if="isActive">Активна</div>
        <div class="label-archive" v-if="!isActive">Архівна</div>
      </div>
      <div class="labels" v-if="editing">
        <div 
          :class="promotion.modes.delivery ? 'label label-edit-active' : 'label' "
           @click="promotion.modes.delivery = !promotion.modes.delivery">
           DELIVERY
        </div>
        <div 
          :class="promotion.modes.preorder ? 'label label-edit-active ml-2' : 'label ml-2' "
          @click="promotion.modes.preorder = !promotion.modes.preorder">
          TAKEAWAY
        </div>

         <div class="label label-delete" @click="emitDelete">Видалити</div>
      </div>
    </div>
    <IQOSActions :editing="editing" @edit="showEditUI" @cancel="hideEditUI" @accept="onEditFinish" />
  </IQOS>
</template>

<script>
import IQOS from "@/components/IQOS.vue";
import IQOSActions from "@/components/IQOSActions.vue";
import BlackInput from "@/components/BlackInput.vue";
import BlackSelect from "@/components/BlackSelect.vue";

import moment from 'moment'

export default {
  props: {
    promotion: Object,
    index: Number
  },
  data() {
    return {
      editing: false,
      range: {
        start: null,
        end: null
      }
    };
  },
  watch: {
    range: {
      handler() {
        this.promotion.period_start = this.range.start;
        this.promotion.period_end = this.range.end;
      },
      deep: true
    }
  },
  components: {
    IQOS,
    IQOSActions,
    BlackInput,
    BlackSelect
  },
  methods: {
    showEditUI() {
      this.editing = true;
    },
    hideEditUI() {
      this.editing = false;
    },
    onEditFinish() {
      this.$emit('finish', this.promotion);
      this.editing = false;
    },
    findMenu(id) {
      return this.$store.getters["menu/getById"](id);
    },
    emitDelete() {
      this.$emit('delete', this.promotion._id);
    }
  },
  mounted() {
    if (this.index == -1) {
      this.editing = true;
    }

    this.range.start = moment(this.promotion.period_start).toDate();
    this.range.end = moment(this.promotion.period_end).toDate();
  },
  computed: {
    menus() {
      return this.$store.state.menu.menus;
    },
    isActive() {
      return moment().isBetween(
        this.promotion.period_start,
        this.promotion.period_end
      );
    }
  }
};
</script>

<style scoped>
.labels {
  display: flex;
}

.label,
.label-active,
.label-archive {
  background: #ededed;
  margin-top: 1.1vh;
  color: #1d1d1d;
  border-radius: 0.8vh;
  font-size: 1.7vh;
  padding: 0.5vh 0;
  min-width: 12vh;
  text-align: center;
  font-weight: bold;
  cursor: pointer;
  border: 2px solid transparent;
}

.label-active {
  margin-left: auto;
  font-weight: normal !important;
  background: #129b81 !important;
  color: #ededed !important;
}

.label-archive {
  margin-left: auto;

  background: #416293 !important;
  color: #ededed;
}

.label-delete {
  margin-left: auto;
  background: #E2223B !important;
  color: #ededed;
  cursor: pointer;
  font-weight: normal;
}

h4,
p {
  font-size: 2.2vh;
}

h4 {
  color: #a4a3a1;
  display: flex;
  line-height: 1.5;
  align-items: baseline;
  margin-bottom: 0;
}

p {
  margin: 0;
  padding-left: 1.1vh;
  color: #ededed;
}

.h-100 {
  height: 100vh !important;
}

.promotion-period {
  width: 63%;
  margin-top: 0;
}

.label-edit-active {
  background: #129b81;
  color: #ededed;
}
</style>
